<script>
export default {
  name: "MediaPreview",
  props: {
    item: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: "100%",
    },
  },
  computed: {
    isImage() {
      return this.item?.mime_type?.startsWith("image/");
    },
    iconClass() {
      const type = this.item?.type;
      const map = {
        pdf: "ri-file-pdf-line media-type-icon-pdf",
        word: "ri-file-word-line media-type-icon-word",
        excel: "ri-file-excel-line media-type-icon-excel",
        powerpoint: "ri-file-ppt-line media-type-icon-powerpoint",
      };
      return map[type] || "ri-file-line media-type-icon-other";
    },
  },
};
</script>

<template>
  <div
    v-if="item"
    class="media-preview-item-thumbnail"
    :style="{ width: size, height: size }"
  >
    <img
      v-if="isImage"
      :src="item.url"
      :alt="item.alt || item.name"
    />
    <i v-else :class="iconClass"></i>
  </div>
</template>
